const WORDS = ["CERAMICS", "LEATHER OBJECTS", "RAW BRASS", "SOY CANDLES", "ARCHIVAL DESKWARE", "STONE & CLAY"];

export default function Marquee() {
  return (
    <div className="overflow-hidden border-y border-white/10 bg-onyx py-5" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee items-center gap-16 whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center gap-16">
            {WORDS.map((w) => (
              <span key={`${half}-${w}`} className="flex items-center gap-16">
                <span className="font-mono text-xs uppercase tracking-[0.4em] text-smoke">{w}</span>
                <span className="font-display text-lg italic text-vermilion/70">est. mmxxvi</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
